export var TabPanelStyles = function () {
    return {
        wrapper: {
            width: "100%",
        },
    };
};
